import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";

export const StyledTitle = styled.h5`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon["500"])};
    margin: 0 0 8px 0;
`;

export const StyledDescription = styled.p`
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["400"])};
    margin: 0;
`;

export const StyledHeaderTextsWrap = styled.div`
    flex-grow: 1;
    flex-shrink: 0;
`;
